<section class="login-block">
  <!-- Container-fluid starts -->
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <!-- Authentication card start -->
        <form  (ngSubmit)="resetPasswordForm.valid && submitResetPassword()" #resetPasswordForm="ngForm" novalidate>
          <div class="text-center">
            <img class="header-logo" src="../../../assets/images/urbansofa_logo_white.png" alt="logo.png">
          </div>
          <div class="auth-box card">
            <div class="card-block">
              <div class="row m-b-20">
                <div class="col-md-12">
                  <h3 class="text-center">{{'auth.reset_password.title'|translate}}</h3>
                </div>
              </div>
              <div class="form-group form-primary">
                <label class="float-label">{{'auth.reset_password.new_password'|translate}}</label>
                <input name="password" strength #password="ngModel" [(ngModel)]="resetPasswordModel.password" type="password" class="form-control" required>
                <span class="form-bar"></span>
                <div class="messages text-danger" *ngIf="password.invalid && password.dirty && password.errors && password.errors?.required">{{'errors.required'|translate}}
                </div>
                <div class="messages text-danger" *ngIf="password.dirty &&  password.errors?.strength">
                  {{password.errors?.strength.value | translate}}
                </div>
              </div>
              <div class="form-group form-primary">
                <label class="float-label">{{'doctrine.user.plainPasswordConfirm'|translate}}</label>
                <input name="confirmation" appValidateEqual="password" #confirmation="ngModel" [(ngModel)]="resetPasswordModel.passwordConfirmation" type="password" class="form-control" required>
                <span class="form-bar"></span>
                <div class="messages text-danger" *ngIf="confirmation.invalid && confirmation.dirty && confirmation.errors && confirmation.errors['required']">{{'errors.required'|translate}}</div>
                <div class="messages text-danger" *ngIf="confirmation.dirty && resetPasswordModel.password !== resetPasswordModel.passwordConfirmation">{{'auth.reset_password.confirm_password.notequal'|translate}}</div>
              </div>
              <div class="row m-t-30">
                <div class="col-md-12">
                  <button [disabled]="!resetPasswordForm.valid" [ngClass]="{'btn-disabled': !resetPasswordForm.valid, 'disabled': !resetPasswordForm.valid}" type="submit" class="btn btn-primary btn-md btn-block text-center m-b-20 ripple light">{{'global.reset_password'|translate}}</button>
                </div>
              </div>
              <hr/>
              <div class="row">
                <div class="col-md-12">
                  <a class="text-justify text-inverse m-b-0">{{ 'validators.password.info' | translate }}</a>
                </div>
              </div>
            </div>
          </div>
        </form>
        <!-- end of form -->
      </div>
      <!-- end of col-sm-12 -->
    </div>
    <!-- end of row -->
  </div>
  <!-- end of container-fluid -->
</section>
